import Badge from '../common/Badge';
import { fmt } from '../../utils/formatters';

export default function InvoiceListItem({ invoice, onOpen, onDelete, onDownload }) {
  return (
    <div className="inv-card" onClick={() => onOpen(invoice)}>
      <div className="inv-card-left">
        <div className="inv-no">
          {invoice.invoiceNo}
          {invoice.sourceFolderName && (
            <span style={{ fontWeight: 400, color: 'var(--muted)', fontSize: 12, marginLeft: 8 }}>
              · {invoice.sourceFolderName}
            </span>
          )}
        </div>
        <div className="inv-meta">
          {invoice.supplier && <span>{invoice.supplier}</span>}
          {invoice.items?.length && <span>· {invoice.items.length} item{invoice.items.length !== 1 ? 's' : ''}</span>}
          {invoice.autoAddedItems?.length > 0 && <span className="auto-badge">auto-filled</span>}
          {invoice.subInvoices?.length > 0 && (
            <span className="auto-badge" style={{ background: 'var(--gold-light, #c4963a)', color: '#fff', borderRadius: 4, padding: '1px 6px', fontSize: 11, fontWeight: 600 }}>
              {invoice.subInvoices.length} sub-invoice{invoice.subInvoices.length !== 1 ? 's' : ''}
            </span>
          )}
          {invoice.driveWebViewLink && (
            <a
              href={invoice.driveWebViewLink}
              target="_blank"
              rel="noreferrer"
              className="drive-badge"
              onClick={e => e.stopPropagation()}
            >
              📁 Drive
            </a>
          )}
          <Badge variant={invoice.status === 'synced' ? 'success' : invoice.status === 'saved' ? 'blue' : 'gray'}>
            {invoice.status}
          </Badge>
        </div>
      </div>
      <div className="inv-card-right">
        <div>
          <div className="inv-amount">{fmt(invoice.grandTotal)}</div>
          {invoice.vatAmount > 0 && <div className="inv-vat">incl. {fmt(invoice.vatAmount)} VAT</div>}
        </div>
        <button
          className="btn-icon download"
          onClick={e => { e.stopPropagation(); onDownload(invoice._id); }}
          title="Download XLSX"
        >
          📥
        </button>
        <button className="btn-icon" onClick={e => { e.stopPropagation(); onDelete(invoice._id); }} title="Delete">🗑</button>
      </div>
    </div>
  );
}
